import { forwardRef } from 'react';

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(function (
  { className: _className, ...rest },
  ref
) {
  const className = [
    'border',
    'text-[--c-textinput-text]',
    'block',
    / ?w-/.test(_className || '') ? undefined : 'w-full',
    'p-2.5',
    'border-1',
    'border-[--c-textinput-border]',
    'bg-[--c-textinput-background]',
    _className,
  ].join(' ');
  return <input {...rest} className={className} ref={ref} />;
});
Input.displayName = 'Input';
